module.exports = __webpack_public_path__ + "img/picture.b0829d8e.jpg";